export const scrollToId = (id, offset = 0) => {
    const el = document.querySelector(id);
    if (!el) return;
    // numeric offset is robust against 3D-transformed ancestors (Lenis offsetTop fails there)
    const y = el.getBoundingClientRect().top + window.scrollY + offset;
    // force native smooth scroll through Lenis (immediate:false lets Lenis animate the native scroll)
    if (window.__lenis) {
        window.__lenis.scrollTo(y, {
            duration: 1.4,
            easing: (t) => 1 - Math.pow(1 - t, 4),
            force: true,
        });
        // hard fallback in case the 3D-transform ancestor still blocks the virtual scroll
        setTimeout(() => {
            const current = window.scrollY;
            if (Math.abs(current - y) > 120) {
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }, 250);
    } else {
        window.scrollTo({ top: y, behavior: "smooth" });
    }
};
